import Image from "next/image";
import CommonTitle from "@/components/common/CommonTitle";
import aes256EncryptionLogo from "@/assets/images/achievements/aes-256-encryption-logo.svg";
import aicpaSoc2Logo from "@/assets/images/achievements/aicpa-soc-2-logo.svg";
import gdprLogo from "@/assets/images/achievements/gdpr-logo.svg";
import achievementImage from "@/assets/images/achievements/achievement-image.svg";
import achievementBgImage from "@/assets/images/achievements/bg-achieve.svg";

const Achievements = () => {
  return (
    <section className="relative z-10 overflow-hidden py-12 xl:py-16">
      <div
        className="absolute left-0 top-0 -z-10 h-full w-full"
        style={{
          backgroundImage: `url(${achievementBgImage.src})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12 xl:gap-16">
          <div className="flex flex-col justify-center gap-4 xl:gap-6">
            <CommonTitle
              as="h2"
              color="#FFFFFF"
              fontSizeClass="text-[24px] xl:text-[32px]"
              fontWeightClass="font-bold"
            >
              Governance-First AI
            </CommonTitle>
            <p className="text-[14px] font-normal leading-relaxed text-white xl:text-[16px] lg:max-w-[500px]">
              Kroolo's security architecture ensures that your proprietary
              business data remains your own. Unlike public models, our agents
              operate within a Private Vector Sandbox that respects internal
              workspace permissions.
            </p>
            <div className="mt-2 flex flex-wrap items-start gap-4 xl:gap-6">
              <Image src={aes256EncryptionLogo} alt="AES-256 encryption - Kroolo security" width={80} height={80} />
              <Image src={aicpaSoc2Logo} alt="AICPA SOC 2 compliance - Kroolo" width={80} height={80} />
              <Image src={gdprLogo} alt="GDPR compliant - Kroolo data protection" width={80} height={80} />
            </div>
          </div>
          <div className="relative flex items-center justify-center">
            <div className="relative h-full w-full overflow-hidden xl:h-[400px]">
              <Image
                src={achievementImage}
                alt="Kroolo Governance-First AI Workload Management Interface"
                width={600}
                height={400}
                className="h-full w-full object-contain"
                priority
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Achievements;
